import React from 'react'
import DemandPlanRealizationPanel from "./DemandPlanRealizationPanel";

function Index(
    {
        expanded
    }) {
    return (expanded && <DemandPlanRealizationPanel/>)
}


export default Index;